var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.276 1.502h9.229c.563 0 1.046.457 1.046 1.047v9.229c0 .563-.456 1.046-1.046 1.046v1.342c1.315 0 2.388-1.073 2.388-2.388V2.522c0-1.315-1.073-2.388-2.388-2.388h-9.23c-1.314 0-2.387 1.073-2.387 2.388h1.341c0-.563.456-1.02 1.047-1.02z",
    transform: "translate(-176 -737) translate(0 721) translate(159 17) translate(18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.385 5.339h9.23c.563 0 1.046.456 1.046 1.046v9.23c0 .563-.456 1.046-1.046 1.046v1.341c1.314 0 2.387-1.073 2.387-2.387v-9.23c0-1.314-1.073-2.387-2.387-2.387h-9.23c-1.314 0-2.387 1.073-2.387 2.387h1.341c0-.563.456-1.046 1.046-1.046z",
    transform: "translate(-176 -737) translate(0 721) translate(159 17) translate(18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.522 21.866h9.23c1.314 0 2.387-1.073 2.387-2.388v-9.23c0-1.314-1.073-2.387-2.388-2.387H2.522c-1.315 0-2.388 1.073-2.388 2.388v9.229c0 1.315 1.073 2.388 2.388 2.388zM1.476 10.249c0-.564.456-1.047 1.046-1.047h9.23c.563 0 1.046.457 1.046 1.047v9.229c0 .563-.457 1.046-1.047 1.046H2.522c-.563 0-1.046-.456-1.046-1.046v-9.23z",
    transform: "translate(-176 -737) translate(0 721) translate(159 17) translate(18)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionsIcon);
export default __webpack_public_path__ + "static/media/subscriptionsIcon.fb7f49c2467bc2eb640c203e70a7e4ae.svg";
export { ForwardRef as ReactComponent };